import { ReactNode } from 'react';
import DisplayError from '../../../../../../components/info/DisplayError';
import { createLoaderImp } from '../../../../../../components/ozmoit/common';
import { useAcademicOfferWizard } from '../../../context/AcademicOfferWizardContext';
import {
  getCoursesWithSectionsAction,
  getCoursesWithSectionsFormDataAction,
} from '../actions';

interface Props {
  children: ReactNode;
}

const {
  useLoader: useCoursesWithSectionsFormDataLoader,
  LoaderProvider: CoursesWithSectionsFormDataLoaderProvider,
} = createLoaderImp({
  action: getCoursesWithSectionsFormDataAction,
});

const {
  useLoader: useCoursesSectionsLoader, //Query search
  LoaderProvider,
} = createLoaderImp({
  action: getCoursesWithSectionsAction,
});

function CoursesSectionsLoaderProvider({
  children,
  ...props
}: Readonly<Parameters<typeof LoaderProvider>[0]>) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

function AcademicOfferSectionLoader({ children }: Readonly<Props>) {
  const { ceAcademicOfferId } = useAcademicOfferWizard();

  if (!ceAcademicOfferId) {
    return <DisplayError textBody="CONNECTION" />;
  }

  return (
    <CoursesSectionsLoaderProvider
      defaultQuery={{ ceAcademicOfferId, items_per_page: 10, page: 1 }}
      fetchImmediately
    >
      {children}
    </CoursesSectionsLoaderProvider>
  );
}

export {
  AcademicOfferSectionLoader,
  useCoursesWithSectionsFormDataLoader,
  CoursesWithSectionsFormDataLoaderProvider,
  useCoursesSectionsLoader,
};
